var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwitchOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icona_switch_on",
    "data-name": "icona switch on",
    transform: "translate(-1017 -110)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icona_switch_on-2",
    "data-name": "icona switch on",
    transform: "translate(1017 118)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_149",
    "data-name": "Rettangolo 149",
    width: 32,
    height: 16,
    rx: 8,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_25",
    "data-name": "Ellisse 25",
    cx: 6.545,
    cy: 6.545,
    r: 6.545,
    transform: "translate(17.455 1.455)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rettangolo_777",
    "data-name": "Rettangolo 777",
    transform: "translate(1017 110)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchOn);
export default __webpack_public_path__ + "static/media/switch_on.2bf230e63e7b06c4535dae21c13cad0f.svg";
export { ForwardRef as ReactComponent };